import React, { createContext, useState, useMemo } from "react";

export const AutoBillContext = createContext();

export default function AutoBillProvider({ children }) {
  const [autoBill, setAutoBill] = useState([]);
  const [total, setTotal] = useState(0);

  const contextValue = useMemo(
    () => ({ autoBill, setAutoBill, total, setTotal }),
    [autoBill, total]
  );
  return (
    <AutoBillContext.Provider value={contextValue}>
      {children}
    </AutoBillContext.Provider>
  );
}
